import React from "react";

import { Icon } from "@chakra-ui/react";
import { MdHome, MdElectricBolt, MdCellTower } from "react-icons/md";
import {
  FaChargingStation,
  FaUser,
  FaHouseUser,
  FaMoneyCheck,
  FaListAlt,
} from "react-icons/fa";
import { LuNfc } from "react-icons/lu";
// Admin Imports
import Dashboard from "views/admin/dashboard";
import Transactions from "views/admin/payouts";
import ChargingStation from "views/admin/chargingStation";
import Ocpi from "views/admin/ocpi";

// Auth Imports
import SignIn from "views/auth/signIn";
import Users from "views/admin/users";
import RfidCards from "views/admin/rfidCards";
import TenantScreen from "views/admin/tenants";
import Partners from "views/admin/partners";
import { RiShakeHandsFill } from "react-icons/ri";
import AccountSettings from "views/admin/account/AccountSettings";
import { allRoles } from "utils/accessLevels";
import { adminsAndManagers } from "utils/accessLevels";
import { onlyAdmins } from "utils/accessLevels";
import { onlyAdminsAndPropertyOwners } from "utils/accessLevels";
import { onlyUAdmins } from "utils/accessLevels";
import Contracts from "views/admin/contracts";
import ChargingManagement from "views/admin/chargingManagement";
import ChargingSessions from "views/admin/chargingSessions";
import PayeeScreen from "views/admin/payees";
import { BsCashStack } from "react-icons/bs";

// Define the routes for navigation
const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/dashboard",
    icon: (
      <Icon
        as={MdHome}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    component: Dashboard,
    accessLevel: 3,
    roles: allRoles,
    element: <Dashboard />,
  },
  {
    name: "Locations",
    layout: "/admin",
    icon: (
      <Icon
        as={FaChargingStation}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    path: "/locations",
    accessLevel: 3,
    roles: allRoles,
    element: <ChargingStation />,
  },
  {
    name: "RFID-Cards",
    layout: "/admin",
    path: "/rfid_cards",
    icon: (
      <Icon
        as={LuNfc}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 2,
    roles: adminsAndManagers,
    element: <RfidCards />,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users",
    icon: (
      <Icon
        as={FaUser}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 1,
    roles: onlyAdmins,
    element: <Users />,
  },
  {
    name: "Tenants",
    layout: "/admin",
    path: "/tenants",
    icon: <Icon as={FaHouseUser} width="20px" height="20px" color="inherit" />,
    accessLevel: 0,
    roles: onlyUAdmins,
    element: <TenantScreen />,
  },

  {
    name: "Account Settings",
    layout: "/account",
    path: "/settings",
    roles: onlyAdminsAndPropertyOwners,
    element: <AccountSettings />,
    accessLevel: 1,
  },
  {
    name: "Partners",
    layout: "/admin",
    path: "/partners",
    icon: (
      <Icon
        as={RiShakeHandsFill}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    roles: onlyUAdmins,
    accessLevel: 0,
    element: <Partners />,
  },
  {
    name: "User Groups",
    layout: "/admin",
    path: "/userprofiles",
    icon: <Icon as={FaHouseUser} width="20px" height="20px" color="inherit" />,
    accessLevel: 0,
    roles: onlyAdmins,
    element: <Contracts />,
  },
  {
    name: "Payees",
    layout: "/admin",
    path: "/payees",
    icon: <Icon as={FaMoneyCheck} width="20px" height="20px" color="inherit" />,
    accessLevel: 0,
    roles: onlyUAdmins,
    element: <PayeeScreen />,
  },
  {
    name: "Payouts",
    layout: "/admin",
    path: "/payouts",
    icon: (
      <Icon
        as={BsCashStack}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 1,
    roles: onlyUAdmins, //TODO:should be admins and property owners
    secondary: true,
    element: <Transactions />,
  },
  // {
  //   name: "Sources",
  //   layout: "/admin",
  //   path: "/sources",
  //   icon: (
  //     <Icon
  //       as={MdTripOrigin}
  //       maxWidth="30px"
  //       maxHeight="40px"
  //       width="30px"
  //       height="50px"
  //       color="inherit"
  //     />
  //   ),
  //   roles: onlyUAdmins,
  //   accessLevel: 0,
  //   element: <Sources />,
  // },
  {
    name: "Charging Management",
    layout: "/admin",
    path: "/charging_management",
    icon: (
      <Icon
        as={MdElectricBolt}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 2,
    roles: adminsAndManagers,
    element: <ChargingManagement />,
  },
   {
    name: "Charging Sessions",
    layout: "/admin",
    path: "/charging_sessions",
    icon: (
      <Icon
        as={FaListAlt}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 2,
    roles: adminsAndManagers,
    element: <ChargingSessions />,
  },
  {
    name: "OCPI",
    layout: "/admin",
    path: "/ocpi",
    icon: (
      <Icon
        as={MdCellTower}
        width="20px" height="20px"
        color="inherit"
      />
    ),
    accessLevel: 0,
    roles: onlyUAdmins,
    element: <Ocpi />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/signIn",
    element: <SignIn />,
  },
];

export default routes;
